import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { setFileSummaryDataAction } from "@oldDashboard/legacyActions/dashboardClient";

interface FileUploadSummary { launchSelected: String, affiliateSelected:String, searching: boolean }
const UseFileUploadSummary = (props:FileUploadSummary) => {
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(() => {
        fetchFileSummaryData();
    }, [props.searching, props.launchSelected]);
   
    const fetchFileSummaryData = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getFileSummaryData(props.launchSelected);
            if (response) {
                setFileSummaryDataAction(response);
            }
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
    }

    return { fetchFileSummaryData, isLoading }
}

export default UseFileUploadSummary;